import globalEvents from '@/services/GlobalEvents/GlobalEvents.ts';
import { Events } from '@/services/GlobalEvents/constants.ts';
import { ShowProps } from './IUserNotify.ts';

export const show = (props: ShowProps) => {
  globalEvents.emit(Events.showUserNotice, props)
}
